import React from "react";
import SuperUserHomePageUI from "../../../templates/SuperUserHomePageUI.js";
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import SpinnerComponentUI from "../../../components/common/SpinnerComponentUI.js";
import CardUI from "../../../widgets/layout/CardUI.js";
import { Link } from "react-router-dom";

const SecurityReportPageUI = ({ context, errorList, dsraReportList, onDownloadDsraReport, onRefreshClick, response }) =>
  <SuperUserHomePageUI context={context} className='pg_su_disb_mon' topnav='accounts'
    headerText='Security Report' centered={!errorList} dimension='w1000' page='dsra'
  >
    {
      !errorList &&
      <SpinnerComponentUI />
    }
    {
      dsraReportList &&
      <LRTableActionsUI location='top'
        left={
          <span className='g_flex_left g_flex_h'>
            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
            <IconButtonUI icon='icon-download' onClick={onDownloadDsraReport} label='Download' />
            <span className='g_m_left_100 g_large'><b>Security Report, {response.yearMonth.monthName} {response.yearMonth.year}</b></span>
          </span>
        }
        right={
          <span>
            <Link to={`/su/security/${response.yearMonth.prevYear}/${response.yearMonth.prevMonth}`}>Previous</Link>
            <span className='g_m_left_100' />
            <Link to={`/su/security/${response.yearMonth.nextYear}/${response.yearMonth.nextMonth}`}>Next</Link>
          </span>
        }
      />
    }
    {
      dsraReportList && <DSRAReportUI dsraReportList={dsraReportList} response={response} />
    }
  </SuperUserHomePageUI>

const DSRAReportUI = ({ dsraReportList, response }) =>
  <div>
    <CardUI title='Security Report' className='g_m_top_100'>
      <table>
        <tbody>
          <tr>
            <th />
            <th>Client Name</th>
            <th>Disbursed</th>
            <th>DSRA </th>
            <th>Contribution By Client</th>
            <th>Current DSRA</th>
            <th>Penalty Charges</th>
            <th>EMI</th>
          </tr>
          {
            dsraReportList.map((dsra, i) =>
              <tr className='acc' key={i}>
                <td className='left'>{i + 1}.</td>
                <td className='left g_no_wrap_2'>{dsra.accountName}</td>
                <td>{dsra.disbursedAmountF4}</td>
                <td>{dsra.dsraAmountF4}</td>
                <td>{dsra.dsraFromLoan ? 'No' : 'Yes'}</td>
                <td>{dsra.currentDsraF4}</td>
                <td>{dsra.defaultInterestF4}</td>
                <td>{dsra.emiF4}</td>
              </tr>
            )
          }
          <tr className='acc'>
            <td><b>Totals</b></td>
            <td />
            <td><b>{response.totalDisbursedF4}</b></td>
            <td><b>{response.totalDsraAmountF4}</b></td>
            <td />
            <td><b>{response.totalCurrentDsraF4}</b></td>
            <td><b>{response.totalDefaultInterestF4}</b></td>
            <td><b>{response.totalEmiF4}</b></td>
          </tr>
          <tr>
            <td></td><td><b>DSRA Requested</b> = {response.dsraReqPercentF}</td><td></td><td></td>
            <td><b>DSRA Current</b> = {response.dsraCurrPercentF}</td>
          </tr>
          <tr>
            <td></td><td><b>Client Contribution</b> = {response.clientContribPercentF}</td><td></td><td></td>
            <td><b>Client Contribution</b> = {response.clientCurrContribPercentF}</td>
          </tr>
          <tr>
            <td></td><td><b>Clime Contribution</b> = {response.climeContribPercentF}</td><td></td><td></td>
            <td><b>Clime Contribution</b> = {response.climeCurrContribPercentF}</td>
          </tr>
        </tbody>
      </table>
    </CardUI>
  </div>


export default SecurityReportPageUI;